module.exports = __webpack_public_path__ + "img/moon_chasers.c2e7fa30.jpg";